import { Link } from 'react-router';

import './DownloadDetailedBreadcrumb.scss';

export const DownloadDetailedBreadcrumb = ({
  artifact,
}: {
  artifact: string;
}) => (
  <div className="download-detailed-breadcrumb">
    <Link to="/">
      <p className="download-detailed-breadcrumb__text download-detailed-breadcrumb__text-link">
        Downloads
      </p>
    </Link>
    <p className="download-detailed-breadcrumb__text">/ {artifact}</p>
  </div>
);
